import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ActivatedRoute } from "@angular/router";
import { v4 as uuidv4 } from "uuid";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { VendorService } from "../../../../core/services/vendor.service";
import { AddContactsDto } from "../../../../core/models/client/addclient/addContactsDto";
import { ContactDto } from "../../../../core/models/client/addclient/contactDto";
import { AddVendorContact } from "../../../../core/models/vendor/addVendor/addVendorContact";
import { LoaderService } from "../../../../core/services/loader.service";
import { ClientPurpose } from "../../../../shared/enums/clientPurpose";
import { EnumContactType } from "../../../../shared/enums/enumContactType";
import { CommonModule } from "@angular/common";
import { DrawerModule } from "primeng/drawer";
import { AddClientContact } from "../../../../core/models/client/addclient/addClientContact";
import { DropdownModule } from "primeng/dropdown";
import { Contact } from "../../../../core/models/shared/contact";
import { SelectModule } from "primeng/select";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { ToggleSwitchModule } from "primeng/toggleswitch";

@UntilDestroy()
@Component({
  selector: "jni-add-contact-information",
  templateUrl: "./add-contact-information.component.html",
  styleUrls: ["./add-contact-information.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    DropdownModule,
    DrawerModule,
    ReactiveFormsModule,
    ToggleSwitchModule,
    SelectModule,
    InputTextModule,
    ButtonModule,
    ToggleSwitchModule,
  ],
})
export class AddContactInformationComponent implements OnInit {
  @Input() isFromVendorSummary = false;
  @Input() loggedInUserIsAdmin = false;
  @Input() display!: boolean;
  vendorForm: FormGroup;
  @Output() displayChange = new EventEmitter<boolean>();
  vendorContactArray: ContactDto[] = [];
  isPrimaryOne = "1";
  isPrimaryZero = "0";
  clientContactArray: AddClientContact[] = [];
  createNewContact = "Create New";
  updateNewContact = "Edit Contact Information";
  @Input() headingStatus = true;
  vendorStatusId = "";
  type = [
    {
      id: 1,
      name: "Business",
    },
    {
      id: 5,
      name: "Invoice",
    },
    {
      id: 5,
      name: "Other",
    },
  ];
  @Input() vendorObject!: Contact;
  @Output() refreshSummary = new EventEmitter<boolean>();
  postingDate: Date = new Date();
  @Input()
  set vendorIdFromModal(value: string) {
    this.vendorStatusId = value;
  }

  constructor(
    private _toastrService: JniToastrService,
    private _formBuilder: FormBuilder,
    private _addvendor: VendorService,
    private router: ActivatedRoute,
    public _loaderService: LoaderService
  ) {
    this.vendorForm = this._formBuilder.group({
      name: ["", [Validators.pattern("^[a-zA-Z0-9 ]+|[\u10D0-\u10F0]+$")]],
      phoneNumber: ["", [Validators.pattern("^[^a-zaA-Z]+$")]],
      email: [
        "",
        [
          Validators.pattern(
            `^[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)?@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`
          ),
        ],
      ],
      type: [""],
      electronicAddressIdD365: [""],
      electronicAddressEmail: [""],
      electronicAddressPhone: [""],
      isPrimary: [false],
      portalKeyPhone: [""],
      portalKeyEmail: [""],
    });

    this.router.params.subscribe(params => {
      this.vendorStatusId = params["id"];
    });
  }

  formErrors: Record<string, string> = {
    name: "",
    email: "",
    phoneNumber: "",
  };

  validationMessages: Record<string, Record<string, string>> = {
    name: {
      pattern: "Name format is not correct.",
    },

    phoneNumber: {
      pattern: "Phone number format is not correct.",
    },
    email: {
      pattern: "Email format is not correct.",
    },
  };

  ngOnInit(): void {
    if (this.vendorObject && this.headingStatus !== true) {
      if (Object.keys(this.vendorObject).length !== 0) {
        this.patchValueInVendorForm(this.vendorObject);
        this.headingStatus = false;
        this.vendorForm.get("type")?.disable();
      }
    } else {
      this.vendorForm.get("type")?.enable();
    }
  }

  logValidationErrors(group: FormGroup = this.vendorForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  purpose = "";
  patchValueInVendorForm(vendorObject: Contact) {
    if (vendorObject.otherSpecification) {
      this.purpose =
        vendorObject.otherSpecification?.toLowerCase() === "inside"
          ? "Invoice"
          : "Other";
    } else {
      this.purpose = vendorObject.purposeD365 ?? "";
    }
    this.vendorForm.patchValue({
      name: vendorObject?.nameD365,
      phoneNumber: vendorObject?.phone,
      email: vendorObject?.email,
      type: this.purpose,
      electronicAddressPhone: vendorObject?.electronicAddressPhone,
      electronicAddressEmail: vendorObject?.electronicAddressEmail,
      isPrimary:
        vendorObject?.isPrimaryD365?.toLowerCase() === "yes" ? true : false,
      portalKeyPhone: vendorObject?.portalKeyPhone,
      portalKeyEmail: vendorObject?.portalKeyEmail,
    });
  }

  onHide() {
    this.displayChange.emit(false);
  }

  addDataInVendortInfoArray(
    vendorContactArray: AddVendorContact,
    locator: string,
    purpose: string,
    isPrimary: string,
    type: string,
    other: string,
    electronicAddress: string,
    portalKey: string
  ) {
    const firstName =
      vendorContactArray.name.split(" ")[0] === undefined
        ? ""
        : vendorContactArray.name.split(" ")[0];
    const lastName =
      vendorContactArray.name.split(" ")[1] === undefined
        ? ""
        : vendorContactArray.name.split(" ")[1];

    const obj: ContactDto = {
      portalKey:
        portalKey === undefined || portalKey === "" ? uuidv4() : portalKey,
      contactName: firstName + " " + lastName,
      contact: locator,
      purpose: parseInt(purpose),
      isPrimary: parseInt(isPrimary),
      type: type == "Phone" ? 1 : 2,
      otherSpecification: other,
      electronicAddress: electronicAddress ?? "",
      createdByPortal: 0,
    };
    return obj;
  }

  addContact(addVendorDto: AddVendorContact, type: string, other: string) {
    if (
      addVendorDto.name != "" ||
      addVendorDto.phoneNumber != "" ||
      addVendorDto.email != ""
    ) {
      this.vendorContactArray.push(
        this.addDataInVendortInfoArray(
          addVendorDto,
          addVendorDto.phoneNumber,
          type,
          addVendorDto.isPrimary === true
            ? this.isPrimaryOne
            : this.isPrimaryZero,
          EnumContactType.Phone,
          other,
          addVendorDto.electronicAddressPhone || "",
          addVendorDto.portalKeyPhone || ""
        ),
        this.addDataInVendortInfoArray(
          addVendorDto,
          addVendorDto.email,
          type,
          addVendorDto.isPrimary === true
            ? this.isPrimaryOne
            : this.isPrimaryZero,
          EnumContactType.Email,
          other,
          addVendorDto.electronicAddressEmail || "",
          addVendorDto.portalKeyEmail || ""
        )
      );
    }
  }

  onSubmit() {
    this._loaderService.setLoaderState(true);
    const addVendorDto = this.vendorForm.getRawValue();

    if (addVendorDto.type === "Business") {
      this.addContact(addVendorDto, ClientPurpose.Business, "");
    } else if (addVendorDto.type === "Invoice") {
      this.addContact(addVendorDto, ClientPurpose.Other, "Inside");
    } else if (addVendorDto.type === "Payable") {
      this.addContact(addVendorDto, ClientPurpose.Other, "");
    } else if (addVendorDto.type === "Delivery") {
      this.addContact(addVendorDto, ClientPurpose.Other, "");
    } else if (addVendorDto.type === "Other") {
      this.addContact(addVendorDto, ClientPurpose.Other, "Website");
    }

    const contactObject: AddContactsDto = {
      accountNumber: this.vendorStatusId,
      contacts: this.vendorContactArray,
    };

    if (this.headingStatus) {
      this._addvendor
        .addContactInformationData(contactObject)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() != "success") {
              this._toastrService.error(
                "Error",
                res.message || "Error In Adding Contacts"
              );
            } else {
              this._toastrService.success(
                "Success",
                res.message || "Contact added Successfully"
              );
            }
            this.displayChange.emit(false);
            this.refreshSummary.emit();
          },
          error: res => {
            this.displayChange.emit(false);
            this._loaderService.setLoaderState(false);
            this._toastrService.error(
              "Error",
              res.message || "Error adding contact"
            );
          },
        });
    } else {
      this._addvendor
        .updateContactInformationData(contactObject)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.status.toLowerCase() != "success") {
              this._toastrService.error(
                "Error",
                res.message || "Error In Updating Contacts"
              );
            } else {
              this._toastrService.success(
                "Success",
                res.message || "Contact Updated SuccessFully"
              );
            }
            this.refreshSummary.emit();
            this.displayChange.emit(false);
          },
          error: res => {
            this._toastrService.error(
              "Error",
              res.message || "Error updating contact"
            );
          },
        });
    }
  }
}
